import ErrorSound from './error.mp3';

const ErrorAudio = new Audio(ErrorSound);

export { ErrorAudio as Error };



// WEBPACK FOOTER //
// ./src/common/Resources/Sounds/index.js